import { render } from "./DistAdminList.vue?vue&type=template&id=0c2081a5&scoped=true&ts=true"
import script from "./DistAdminList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DistAdminList.vue?vue&type=script&setup=true&lang=ts"

import "./DistAdminList.vue?vue&type=style&index=0&id=0c2081a5&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2081a5"],['__file',"src/components/scan/admin/DistAdminList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c2081a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c2081a5', __exports__)) {
    console.log('reload')
    api.reload('0c2081a5', __exports__)
  }
  
  module.hot.accept("./DistAdminList.vue?vue&type=template&id=0c2081a5&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0c2081a5', render)
  })

}


export default __exports__